import React, { Component } from 'react'

import PropTypes from 'prop-types'
import get from 'lodash/get'
import moment from 'moment'

export default class ActivityCard extends Component {
  static propTypes = {
    data: PropTypes.shape({
      title: PropTypes.string,
      shortDescription: PropTypes.string
    }),
    onEditClick: PropTypes.func,
    onDeleteClick: PropTypes.func,
    onPreviewClick: PropTypes.func
  }

  onEditClick() {
    this.props.onEditClick(this.props.data.id)
  }

  onDeleteClick() {
    this.props.onDeleteClick(this.props.data.id)
  }

  onPreviewClick() {
    this.props.onPreviewClick(this.props.data.id)
  }

  renderTime() {
    const start = get(this.props.data, 'tourDates[0].eventDate')
    const end = get(this.props.data, 'tourDates[0].endRepeat')

    let result = ''

    if (start) {
      result += moment(start).format('MMM D')
    }

    if (end) {
      result += ` - ${moment(end).format('MMM D')}`
    }

    return result
  }

  render() {
    return (
      <div className="activity-list__activity-card activity-card">
        <div
          className="activity-card__image"
          style={{
            backgroundImage: `url("${get(this.props.data, 'photos[0].url', 'http://via.placeholder.com/300x200')}")`
          }}
        />
        <div className="activity-card__content">
          <div className="activity-card__info">
            <div className="activity-card__date">{this.renderTime()}</div>
            <div className="activity-card__title">{this.props.data.title}</div>
            <div className="activity-card__description">{this.props.data.shortDescription}</div>
          </div>
          <div className="activity-card__actions actions">
            <button
              className="action action--edit"
              onClick={() => {
                this.onEditClick()
              }}
            >
              <i className="icon-edit" />
            </button>
            <button
              className="action action--edit"
              onClick={() => {
                this.onPreviewClick()
              }}
            >
              <i className="icon-file" />
            </button>
            <button
              className="action action--delete"
              onClick={() => {
                this.onDeleteClick()
              }}
            >
              <i className="icon-delete" />
            </button>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/components/ActivityList/ActivityCard.js